import { render, staticRenderFns } from "./ResendRequests.vue?vue&type=template&id=40ec64de&scoped=true&"
import script from "./ResendRequests.vue?vue&type=script&lang=ts&"
export * from "./ResendRequests.vue?vue&type=script&lang=ts&"
import style0 from "./ResendRequests.vue?vue&type=style&index=0&id=40ec64de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec64de",
  null
  
)

export default component.exports